<template>
  <div id="app">
    <Navigation />
    <div class="container">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
export default {
  name: "App",
  components: {
    Navigation
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
@import url("https://use.typekit.net/ujr3adx.css");
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: $black;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

#app {
  display: grid;
  grid-template-columns: 3.75rem 1fr 3.75rem;
  grid-template-rows: 3.75rem 1fr 3.75rem;
  height: 100vh;
}

.container {
  grid-area: 2 / 2 / 2 / 2;
}

@media screen and (max-width: 812px) {
  .container {
    grid-area: 2 / 1 / 2 / 4;
  }
}

@media screen and (max-width: 1366px) {
  #app {
    min-height: 100vh;
    height: auto;
  }
}
</style>
